module.exports = __webpack_public_path__ + "img/product-placeholder-16.636ba8f.png";